import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {sendMessage, generateId} from 'lib/service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAboutOpen: false,
    isSendingMessage: false,
    messages: [],
    quickReplies: {
      isOpen: false,
      items: []
    }
  },
  mutations: {
    toggleAbout(state) {
      state.isAboutOpen = !state.isAboutOpen;
    },
    toggleSendingMessage(state) {
      state.isSendingMessage = !state.isSendingMessage;
    },
    toggleQuickReplies(state, items) {
      state.quickReplies = {
        isOpen: items && !state.quickReplies.isOpen,
        items: items || []
      };
    },
    closeQuickReplies(state) {
      state.quickReplies = {
        isOpen: false,
        items: []
      };
    },
    receiveMessage(state, message) {
      state.messages = [...state.messages, message];
    },
    receiveMessages(state, messages) {
      // Defaults to zero
      messages = messages.map(msg => ({
        ...msg,
        typing: {
          ...msg.typing,
          wait: msg.typing.wait ? msg.typing.wait : 0,
          duration: msg.typing.duration ? msg.typing.duration : 0
        }
      }));

      // Calculating the real wait taking count previous messages
      for (let i = 0; i < messages.length; i++) {
        const msg = messages[i];

        msg.typing = {
          ...msg.typing,
          wait: i === 0 ?
            msg.typing.wait :
            msg.typing.wait + (
              messages
                .slice(0, messages.indexOf(i))
                .reduce((curr, m) => (curr + m.typing.wait + m.typing.duration), 0)
            )
        }
      }

      state.messages = [...state.messages, ...messages];
    }
  },
  actions: {
    toggleAbout({commit}) {
      commit('toggleAbout')
    },
    toggleQuickReplies({commit}, items) {
      commit('toggleQuickReplies', items);
    },
    async sendMessage({commit}, message) {
      commit('toggleSendingMessage');
      commit('closeQuickReplies');
      commit('receiveMessage', {
        id: 'mk-chat-' + generateId(),
        type: 'text',
        owner: 'user',
        text: message
      });

      const {data: {messages}} = await sendMessage(message);

      commit('toggleSendingMessage');
      commit('receiveMessages', messages);
    },
    async start({commit}) {
      const {data: {messages}} = await sendMessage('start');
      commit('receiveMessages', messages);
    },
  }
});
